
interface window {
    photoOrg: any;
}
/**
 * To handle the caching the Api response
 * As of now, we are saving api responses in two keys, owned and shared.
 * Deleting cache is handled through custom events and event name is- 'delete_response_cache'.
 * Availability scope of RespCacheHelper object will be window.photoOrg scope. 
 */
export class RespCacheHelper {
    private ownedCacheKey:string = "owned";
    private sharedCacheKey:string = "shared";
    private cache:any = {owned : {}, shared : {}};
    public static isRespCachingEnabled = false;

    //To avoid creation of object from outside.
    private constructor(){
    }

    /**
     * To create RespCacheHelper object only once.
     */
    static getInstance():RespCacheHelper{   
        (window as any).photoOrg = (window as any).photoOrg || {};    
        if((window as any).photoOrg.respCacheHelper === undefined){
            (window as any).photoOrg.respCacheHelper = new RespCacheHelper();
            (window as any).addEventListener("delete_response_cache", (window as any).photoOrg.respCacheHelper.deleteRespCache);
        }    
        return (window as any).photoOrg.respCacheHelper;
    }
       
    /**
     * To save owned asset apis. 
     * @param url 
     * @param response 
     */
    saveOwnedRespToCache(url:string, response:any):any{
        //url as key and value will be response.
        this.cache['owned'][url] = response;
    }
    /**
     * To save shared apis response.
     * @param url 
     * @param response 
     */
    saveShareRespToCache(url:string, response:any):any{
        //url as key and value will be response.
        this.cache['shared'][url] = response;
    }
    /**
     * To read owned asset api based url.
     * @param url 
     */
    readOwnedRespFromCache(url:string):any{
        return this.cache['owned'][url];
    }
    /**
     * To read shared asset api based url
     * @param url
     */
    readShareRespFromCache(url:string):any{
        return this.cache['shared'][url];
    }
    /**
     * To save api response based on cache key(owned or shared)
     * url as key and value will be translated api response.
     * @param typeOfCache 
     * @param url 
     * @param response 
     */
    saveToCache(typeOfCache: string, url:string, response:any):any{
        if(typeOfCache === this.ownedCacheKey){
            this.saveOwnedRespToCache(url, response);
        }else if(typeOfCache === this.sharedCacheKey){
            this.saveShareRespToCache(url, response);
        }
    }
    /**
     * To read api response from cache based url.
     * @param typeOfCache 
     * @param url 
     */
    readFromCache(typeOfCache: string, url:string):any{
        if(typeOfCache === this.ownedCacheKey){
            return this.readOwnedRespFromCache(url);
        }else if(typeOfCache === this.sharedCacheKey){
            return this.readShareRespFromCache(url);
        }
        return null;
    }    
    /**
     * To update response cache feature status
     * @param isRespCachingEnabled
     */
    static updateFeatureStatus(isRespCachingEnabled: boolean){
        this.isRespCachingEnabled = isRespCachingEnabled;
    }
    /**
     * To delete the cache based on value from event object.
     * @param event
     */
    deleteRespCache(event:any){
        if((window as any).photoOrg.respCacheHelper.cache[event.detail.cacheKey]){
            (window as any).photoOrg.respCacheHelper.cache[event.detail.cacheKey] = {};
        }else if(event.detail.cacheKey === "all"){
            (window as any).photoOrg.respCacheHelper.cache = {owned : {}, shared : {}};
        }
    }
}

